import IndexPage from './IndexPage.vue';

export default IndexPage;